var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Box as MuiBox, Typography } from '@mui/material';
import { MovieIcon, StoryIcon } from '../../atoms/Icons';
import IconLink from '../../atoms/IconLink';
var Box = styled(MuiBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  a {\n    margin-left: 16px;\n    color: #333;\n  }\n"], ["\n  a {\n    margin-left: 16px;\n    color: #333;\n  }\n"])));
var CountryTitle = function (_a) {
    var code = _a.code, countryInformation = _a.countryInformation;
    var t = useTranslation().t;
    var renderCountryStoryLink = React.useCallback(function () {
        if (!(countryInformation === null || countryInformation === void 0 ? void 0 : countryInformation.storyUrl))
            return null;
        return (React.createElement(Box, null,
            React.createElement(IconLink, { title: t('links.story'), to: countryInformation.storyUrl, icon: React.createElement(StoryIcon, null), external: true })));
    }, [countryInformation, t]);
    var renderCountryMovieLink = React.useCallback(function () {
        if (!(countryInformation === null || countryInformation === void 0 ? void 0 : countryInformation.movieUrl))
            return null;
        return (React.createElement(Box, null,
            React.createElement(IconLink, { title: t('links.movie'), to: countryInformation.movieUrl, icon: React.createElement(MovieIcon, null), external: true })));
    }, [countryInformation, t]);
    return (React.createElement(Typography, { component: Box, variant: "h3", display: "flex", flexWrap: "wrap", my: 1 },
        React.createElement(Box, null, t("countries.".concat(code), { lng: 'en' })),
        renderCountryStoryLink(),
        renderCountryMovieLink()));
};
export default CountryTitle;
var templateObject_1;
